import styled from 'styled-components';

import {
  flexbox,
  flexDirection,
  alignItems,
  justifyContent
} from '../../styles/helpers/flexbox';

export const ModalBody = styled.div((props) => {
  const { palette } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column')};
    ${alignItems('center')};

    width: 800px;
    min-height: 450px;

    color: ${palette.primary.dark};
  `;
});

export const StudentDetails = styled.div`
  ${flexbox()};
  ${justifyContent('center')};
  ${flexDirection('column')};

  margin-bottom: 10px;
`;

export const StudentName = styled.div`
  font-size: 21px;
  line-height: 31px;
`;

export const ActivityName = styled.div`
  font-size: 16px;
  line-height: 25px;
`;

export const LoaderWrapper = styled.div`
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('center')};

  min-height: 450px;
`;

export const ResultsHeading = styled.div((props) => {
  const { colours } = props.theme;

  return `
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('center')};

  background-color: white;
  border: 1px solid ${colours.grey[300]};
  border-radius: 15px 15px 0px 0px;
  border-bottom: none;
  height: 38px;
  width: 148px;
  padding-top: 5px;
  margin-bottom: -6px;
  z-index: 1;
  `;
});

export const ResultsWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
  ${flexbox()};
  ${flexDirection('column')};
  ${alignItems('center')};

  border: 1px solid ${colours.grey[300]};
  border-radius: 15px;
  height: 100%;
  width: 100%;
  padding-top: 25px;
  padding-bottom: 10px;
  margin-top: 5px;
`;
});

export const AttemptsWrapper = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('space-evenly')};

  width: 100%;
`;

export const AssignedActivityWrapper = styled.div`
  ${flexbox()};
  ${alignItems('center')};

  width: 88%;
  margin-top: 10px;
`;

export const Footer = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('flex-end')};

  width: 100%;
  margin-top: 10px;

  .okButton {
    width: 100px;
  }
`;

export const ActivityProgressWrapper = styled.div((props) => {
  const { palette } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column')};
    ${alignItems('center')};

    margin-left: 25px;
    color: ${palette.primary.dark};
  `;
});

export const ActivityProgressTitle = styled.div`
  ${flexbox()};

  width: 100%;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
`;

export const ChartWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
    border: 1px solid ${colours.grey[300]};
    border-radius: 4px;
    box-sizing: border-box;
    height: 162px;
    width: 520px;
    overflow: hidden;
`;
});

export const IconWrapper = styled.div`
  margin-right: 10px;
  width: 20px;
  height: 20px;
`;



// WEBPACK FOOTER //
// ./components/results-modal/results.styled.js